module.exports = __webpack_public_path__ + "img/0.a1841b41.png";